import React, {Component} from 'react'

class HistoryHead extends Component {
    render() {
        return (
            <thead className='HistoryHead'>
                <tr>
                    <th className="colID">#</th>
                    <th className="colTime">Time</th>
                    <th className="colUser">Người tạo</th>
                    <th className="colIP">IP</th>
                    <th className="colKey">Key</th>
                    <th className='colNote'>Note</th>
                </tr>
            </thead>
        )
    }
}

export default HistoryHead